import React from 'react';
import Slider from 'react-slick';
import useMediaQuery from '@mui/material/useMediaQuery';

import Banner1 from '../../../asset/CocopeatAssests/Cocobanner1.jpg';
import Banner2 from '../../../asset/CocopeatAssests/Cocobanner2.jpg';

import MobBanner1 from '../../../asset/CocopeatAssests/Cocobanner1.jpg';
import MobBanner2 from '../../../asset/CocopeatAssests/Cocobanner2.jpg';

const Carousel = () => {
  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    speed: 500,            // transition speed
    autoplaySpeed: 2000,   // time between slides
    arrows: false
  };

  const isLargeScreen = useMediaQuery('(min-width:430px)');

  const desktopBanners = [Banner1, Banner2];
  const mobileBanners = [MobBanner1, MobBanner2];

  const bannersToShow = isLargeScreen ? desktopBanners : mobileBanners;

  return (
    <Slider {...settings}>
      {bannersToShow.map((banner, index) => (
        <div key={index}>
          <img
            src={banner}
            width="100%"
            style={{ maxHeight: '50vh' }}
            alt={`banner-${index}`}
          />
        </div>
      ))}
    </Slider>
  );
};

export default Carousel;
